var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "modal-indexes" } }, [
    _c("h3", { staticClass: "title-modal" }, [_vm._v("Add Index")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "wrap-column-field" },
      _vm._l(_vm.dataSetup, function(data, index) {
        return _c(
          "div",
          { key: "field-column-" + index, staticClass: "columns" },
          [
            _c("p", { staticClass: "mb-1" }, [_vm._v("Column")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "d-flex align-items-center",
                class: {
                  "error-input":
                    _vm.$v.dataSetup.$error &&
                    !_vm.$v.dataSetup.$model[index].column
                }
              },
              [
                _c("j-single-select", {
                  attrs: {
                    "error-required": false,
                    options: _vm.columns,
                    placeholder: "Select Column"
                  },
                  on: {
                    input: function($event) {
                      _vm.validationOptions($event, index)
                    }
                  },
                  model: {
                    value: data.column,
                    callback: function($$v) {
                      _vm.$set(data, "column", $$v)
                    },
                    expression: "data.column"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "definition",
                    class: { "mr-4": index === 0 },
                    attrs: { id: "column-sort-" + index },
                    on: {
                      click: function($event) {
                        _vm.openDropdownSort(index)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "d-flex align-items-center" }, [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/icon/" +
                            (data.type === 1 ? "asc" : "desc") +
                            ".svg")
                        }
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(data.type === 1 ? "ASC" : "DESC"))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "fa fa-chevron-down" })
                  ]
                ),
                _vm._v(" "),
                index > 0
                  ? _c("i", {
                      staticClass: "fa fa-trash delete-column",
                      on: {
                        click: function($event) {
                          _vm.dataSetup.splice(index, 1)
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-popover",
              {
                ref: "column-sort-" + index,
                refInFor: true,
                attrs: {
                  target: "column-sort-" + index,
                  triggers: "manual",
                  placement: "bottom",
                  container: "modal-indexes"
                }
              },
              _vm._l(_vm.sorts, function(sort) {
                return _c(
                  "div",
                  {
                    key: sort.id,
                    staticClass: "sort",
                    on: {
                      click: function($event) {
                        data.type = sort.id
                        _vm.openDropdownSort(index)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon/" +
                          sort.text.toLowerCase() +
                          ".svg")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(sort.text))])
                  ]
                )
              })
            )
          ],
          1
        )
      })
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "add-field mt-2 mb-4", on: { click: _vm.addField } },
      [
        _c("img", { attrs: { src: require("@/assets/icon/add.png") } }),
        _vm._v("\n    Add\n  ")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex align-items-center justify-content-end" },
      [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "button-blue", on: { click: _vm.addIndexes } },
          [_vm._v("\n      Apply\n    ")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60d66122", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60d66122","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/joanadb/dataset/partials/modalAddIndexes.vue
// module id = null
// module chunks = 